"use client"

import { Text } from "@/elements"
import clsx from "clsx"
import { formatDistance } from "date-fns"
import { useSidebar } from "../Sidebar/useSidebar"
import adjustDateForTimezone from "@/utils/dates"

interface Props {
  TextContent: React.ReactNode
  time?: Date
  onClick?: (e: React.MouseEvent<any, MouseEvent>) => void
  onMouseEnter?: () => void
  LeftComponent?: React.ReactNode
  ActionsBar?: React.ReactNode
  isSeen?: boolean | null
}

export const NotificationItemTemplate: React.FC<Props> = ({
  TextContent,
  time,
  onClick,
  onMouseEnter,
  LeftComponent,
  ActionsBar,
  isSeen = true,
}) => {
  const { closeSecondaryBar } = useSidebar()
  const formattedTime = time
    ? formatDistance(time, adjustDateForTimezone(new Date().toISOString())!, { addSuffix: true }) // TODO: properly implement this to match design with shorthand durations (1h, 2d, 3wk, etc)
    : null

  return (
    <div
      onClick={e => {
        if (onClick) {
          e.preventDefault()
          e.stopPropagation()
          onClick(e)
          closeSecondaryBar()
        }
      }}
      onMouseEnter={onMouseEnter}
      className={clsx(
        "relative flex w-full flex-row items-center rounded-md p-2",
        !!onClick && "cursor-pointer hover:bg-bg-2"
      )}>
      <div className={clsx("flex w-full flex-row", !!ActionsBar ? "items-start" : "items-center")}>
        {LeftComponent && <div className="pr-3">{LeftComponent}</div>}
        <div className="flex flex-grow flex-col">
          <Text>
            {TextContent}
            {formattedTime && (
              <Text element="span" className="text-fg-3">
                {" "}
                {formattedTime}
              </Text>
            )}
          </Text>
          {ActionsBar}
        </div>
        {!isSeen && <div className="ml-4 flex size-[10px] flex-shrink-0 rounded-full bg-primary-3" />}
      </div>
    </div>
  )
}
